import React from 'react';
import { LOGO, LOGO_CIRCLE } from '../constants/images';
import { IS_DEVELOPMENT, IS_LOCAL } from '../config';
import '../App.css';

function LandingPage({ onLoginClick }) {
  return (
    <div className="app-container">
      {/* Header with Login button instead of user profile */}
      <header className="header">
        <div className="header-content">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem'
            }}
          >
            <img
              src={LOGO}
              alt="Brings to Mind Logo"
              style={{
                height: '60px',
                width: 'auto'
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h1 style={{ margin: 0, textAlign: 'left' }}>
                BRINGS TO MIND{IS_DEVELOPMENT ? ' - Development' : IS_LOCAL ? ' - Local Dev' : ''}
              </h1>
              <p style={{ margin: 0, textAlign: 'left' }}>REFLECTIONS ON ALL LIFE'S MOMENTS</p>
            </div>
          </div>
          <div className="user-info">
            <button
              className="login-button"
              onClick={onLoginClick}
              style={{
                padding: '0.5rem 1.5rem',
                fontSize: '1rem',
                fontWeight: '600',
                borderRadius: '0.5rem',
                border: 'none',
                background: 'var(--color-primary)',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.opacity = '0.9'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              Login
            </button>
          </div>
        </div>
      </header>

      {/* Landing page content */}
      <div className="landing-content" style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '3rem 2rem',
        textAlign: 'center'
      }}>
        {/* Circle logo */}
        <img
          src={LOGO_CIRCLE}
          alt="Brings to Mind Circle Logo"
          style={{
            width: '200px',
            height: '200px',
            margin: '0 auto 2rem',
            display: 'block'
          }}
        />

        {/* Description text */}
        <div style={{
          fontSize: '1.1rem',
          lineHeight: '1.8',
          color: 'var(--color-text)',
          textAlign: 'left'
        }}>
          <p>
            Brings to Mind provides a place to capture your memories and reflections on your life.
            There's over 200 prompts to get your juices flowing or you can create your own custom prompts.
          </p>

          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            margin: '2rem 0 1rem',
            textAlign: 'left'
          }}>
            The Mission
          </h2>

          <p>
            Imagine an application that becomes the keeper of our most cherished memories, a digital
            sanctuary where the tapestry of our lives unfurls in vibrant detail. We invite people to
            capture the essence of their lives by recording videos that tell the stories that define
            them. With a gentle nudge from thoughtfully crafted prompts, it encourages users to
            reminisce, reflect, and share.
          </p>

          <p>
            Brings to Mind is a time capsule for your unique narratives, a testament to the beauty of
            human experience. In an era when moments too easily slip through the cracks of our memory,
            we strive to ensure that our stories are not lost to the fog of time but preserved,
            celebrated, and shared for generations to come.
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
